module.exports = __webpack_public_path__ + "img/1486358648.755cba52.jpg";